<div class="limit-container">
  <div class="header-row">
    <button class="close-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="content">
    <div class="lock_title">
      <div class="lock_title2">
        <div class="icon-wrapper">
          <mat-icon class="material-icons-outlined">lock</mat-icon>
        </div>
        <div class="title">{{ data.title || 'Feature Limit Reached' | translate }}</div>
      </div>

      <div class="subtitle">
        {{ data.message ? (data.message | translate) : "You've reached the maximum of " + data.max + ' ' + data.itemName + ' allowed on your current plan. Upgrade to Pro to add unlimited ' + data.itemName + '.' }}
      </div>
    </div>

    <div class="buttons">
      <button class="upgrade-btn" (click)="upgrade()">
        {{ data.cta || 'Upgrade Plan' | translate }}
      </button>
      <button class="maybe_later_btn" (click)="close()">{{ 'Maybe Later' | translate }}</button>
    </div>
  </div>
</div>
